import classNames from "classnames";
import { underscored } from "underscore.string";
import PropTypes from "prop-types";
import React from "react";
import Logo from "./Logo";
import { serverStaticUrl } from "../config";
import styles from "../styles/header.module.scss";

const Header = ({ className, title, theme, illustration }) => {
  const headerClassess = classNames(styles.header, className);
  const headerBg = `${serverStaticUrl}/decision-aids/headers/${underscored(
    theme
  )}.svg`;
  const illustrationBg = `${serverStaticUrl}/decision-aids/illustrations/${underscored(
    illustration
  )}.svg`;
  return (
    <div
      className={headerClassess}
      style={{
        background: `url(${headerBg}) 0 0 no-repeat`,
        backgroundSize: "cover"
      }}
    >
      <Logo />
      <div className={styles.row}>
        <div className={styles.title}>{title}</div>
        <div
          className={styles.illustration}
          style={{
            background: `url(${illustrationBg}) no-repeat 50% 50%`
          }}
        />
      </div>
    </div>
  );
};

Header.propTypes = {
  className: PropTypes.string,
  illustration: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

Header.defaultProps = {
  className: ""
};

export default Header;
